import { render, staticRenderFns } from "./BranchHelpList.vue?vue&type=template&id=4a33e782&"
import script from "./BranchHelpList.vue?vue&type=script&lang=js&"
export * from "./BranchHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports